import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadItem, ShEditorComponent, ShFileInputComponent } from '@shs-digi-care-monorepo/frontend-lib';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';

export type RequestRequestorFeedbackDialogData = Record<string, never>;
export interface RequestRequestorFeedbackDialogResult {
    comment: string | null;
    attachments: FileUploadItem[] | null;
}

@Component({
    selector: 'app-request-requestor-feedback-dialog',
    templateUrl: './request-requestor-feedback-dialog.component.html',
    imports: [
        TranslateModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ShEditorComponent,
        ShFileInputComponent,
        DialogWrapperComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RequestRequestorFeedbackDialog {
    private readonly dialogRef = inject<MatDialogRef<RequestRequestorFeedbackDialog>>(MatDialogRef);
    public data = inject<RequestRequestorFeedbackDialogData>(MAT_DIALOG_DATA);

    protected formGroup = new FormGroup({
        comment: new FormControl<string | null>(null),
        attachments: new FormControl<FileUploadItem[] | null>(null)
    });

    public close(): void {
        this.dialogRef.close();
    }

    public confirm(): void {
        this.dialogRef.close(this.formGroup.value);
    }
}
